import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneScientificCommittee = createAsyncThunk(
  "ScientificCommittee/GetOneScientificCommittee",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/ScientificCommittee/GetOneScientificCommittee",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddScientificCommittee = createAsyncThunk(
  "ScientificCommittee/AddScientificCommittee",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/ScientificCommittee/AddScientificCommittee",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteScientificCommittee = createAsyncThunk(
  "ScientificCommittee/DeleteScientificCommittee",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/ScientificCommittee/DeleteScientificCommittee",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetScientificCommitteeInfoRowByUserId = createAsyncThunk(
  "GetScientificCommitteeInfoRowByUserId/GetScientificCommitteeInfoRowByUserId",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/ScientificCommittee/GetScientificCommitteeInfoRowByUserId",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetScientificCommitteeListByFieldIdSubjectId = createAsyncThunk(
  "GetScientificCommitteeInfoRowByUserId/GetScientificCommitteeListByFieldIdSubjectId",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/ScientificCommittee/GetScientificCommitteeListByFieldIdSubjectId",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const CompletionRecommendationApplicationsButton = createAsyncThunk(
  "CompletionRecommendationApplications/CompletionRecommendationApplications",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/CompletionRecommendationApplications",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const RecommendationScientificBodyButtons = createAsyncThunk(
  "RecommendationScientificBody/RecommendationScientificBody",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/RecommendationScientificBody",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllSubTaskForScientificBodyAssigningBysubtask = createAsyncThunk(
  "GetAllSubTaskForScientificBodyAssigningBysubtask/GetAllSubTaskForScientificBodyAssigningBysubtask",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/SubTask/GetAllSubTaskForScientificBodyAssigningBysubtask",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const ScientificCommittee = createSlice({
  name: "ScientificCommittee",
  initialState: {
    //------------- GetOneScientificCommittee ---------------------
    ScientificCommitteeById: {},
    loadingScientificCommitteeById: false,
    errorScientificCommitteeById: null,
    //------------- AddScientificCommittee ---------------------
    AddScientificCommittee: {},
    loadingAddScientificCommittee: false,
    errorAddScientificCommittee: null,
    //------------- DeleteScientificCommittee ---------------------
    DeleteScientificCommittee: {},
    loadingDeleteScientificCommittee: false,
    errorDeleteScientificCommittee: null,
    //-------------------------------------------------------
    ScientificCommitteeInfoRow: [],
    loadingScientificCommitteeInfoRow: false,
    errorScientificCommitteeInfoRow: null,

    //-------------------------------------------------------
    GetScientificCommitteeListByFieldIdSubjectId: [],
    loadingGetScientificCommitteeListByFieldIdSubjectId: false,
    errorGetScientificCommitteeListByFieldIdSubjectId: null,
    //--------------------------------------------------------
    GetAllSubTaskForScientific: [],
    loadingGetAllSubTaskForScientific: false,
    errorGetAllSubTaskForScientific: null,
    //--------------------------------------------
    CompletionRecommendationApplications: {},
    loadingCompletionRecommendationApplications: false,
    errorCompletionRecommendationApplications: null,
    //--------------------------------------------
    //--------------------------------------------
    RecommendationScientificBodyButtons: {},
    loadingRecommendationScientificBodyButtons: false,
    errorRecommendationScientificBodyButtons: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOneScientificCommittee.pending, (state, action) => {
        state.loadingScientificCommitteeById = true;
        state.ScientificCommitteeById = action.payload;
        state.errorScientificCommitteeById = null;
      })
      .addCase(GetOneScientificCommittee.fulfilled, (state, action) => {
        state.loadingScientificCommitteeById = false;
        state.ScientificCommitteeById = action.payload;
      })
      .addCase(GetOneScientificCommittee.rejected, (state, action) => {
        state.loadingScientificCommitteeById = false;
        state.ScientificCommitteeById = action.payload;
      });
    //----------------------AddScientificCommittee---------------------
    builder
      .addCase(AddScientificCommittee.pending, (state, action) => {
        state.loadingAddScientificCommittee = true;
        state.AddScientificCommittee = action.payload;
        state.errorAddScientificCommittee = null;
      })
      .addCase(AddScientificCommittee.fulfilled, (state, action) => {
        state.loadingAddScientificCommittee = false;
        state.AddScientificCommittee = action.payload;
      })
      .addCase(AddScientificCommittee.rejected, (state, action) => {
        state.loadingAddScientificCommittee = false;
        state.AddScientificCommittee = action.payload;
      });
    //-----------------------CompletionRecommendationApplications---------
    builder
      .addCase(
        CompletionRecommendationApplicationsButton.pending,
        (state, action) => {
          state.loadingCompletionRecommendationApplications = true;
          state.CompletionRecommendationApplications = action.payload;
          state.errorCompletionRecommendationApplications = null;
        }
      )
      .addCase(
        CompletionRecommendationApplicationsButton.fulfilled,
        (state, action) => {
          state.loadingCompletionRecommendationApplications = false;
          state.CompletionRecommendationApplications = action.payload;
        }
      )
      .addCase(
        CompletionRecommendationApplicationsButton.rejected,
        (state, action) => {
          state.loadingCompletionRecommendationApplications = false;
          state.CompletionRecommendationApplications = action.payload;
        }
      );
    //----------------------DeleteScientificCommittee---------------------
    builder
      .addCase(DeleteScientificCommittee.pending, (state, action) => {
        state.loadingDeleteScientificCommittee = true;
        state.DeleteScientificCommittee = action.payload;
        state.errorDeleteScientificCommittee = null;
      })
      .addCase(DeleteScientificCommittee.fulfilled, (state, action) => {
        state.loadingDeleteScientificCommittee = false;
        state.DeleteScientificCommittee = action.payload;
      })
      .addCase(DeleteScientificCommittee.rejected, (state, action) => {
        state.loadingDeleteScientificCommittee = false;
        state.DeleteScientificCommittee = action.payload;
      })
      .addCase(
        GetScientificCommitteeInfoRowByUserId.pending,
        (state, action) => {
          state.loadingScientificCommitteeInfoRow = true;
          state.ScientificCommitteeInfoRow = action.payload;
          state.errorScientificCommitteeInfoRow = null;
        }
      );
    builder
      .addCase(
        GetScientificCommitteeInfoRowByUserId.fulfilled,
        (state, action) => {
          state.loadingScientificCommitteeInfoRow = false;
          state.ScientificCommitteeInfoRow = action.payload;
        }
      )
      .addCase(
        GetScientificCommitteeInfoRowByUserId.rejected,
        (state, action) => {
          state.loadingScientificCommitteeInfoRow = false;
          state.ScientificCommitteeInfoRow = action.payload;
        }
      );
    ////////////////////////////////////////////////////
    builder
      .addCase(
        GetScientificCommitteeListByFieldIdSubjectId.pending,
        (state, action) => {
          state.loadingGetScientificCommitteeListByFieldIdSubjectId = true;
          state.GetScientificCommitteeListByFieldIdSubjectId = action.payload;
          state.errorGetScientificCommitteeListByFieldIdSubjectId = null;
        }
      )
      .addCase(
        GetScientificCommitteeListByFieldIdSubjectId.fulfilled,
        (state, action) => {
          state.loadingGetScientificCommitteeListByFieldIdSubjectId = false;
          state.GetScientificCommitteeListByFieldIdSubjectId = action.payload;
        }
      )
      .addCase(
        GetScientificCommitteeListByFieldIdSubjectId.rejected,
        (state, action) => {
          state.loadingGetScientificCommitteeListByFieldIdSubjectId = false;
          state.GetScientificCommitteeListByFieldIdSubjectId = action.payload;
        }
      );
    ////////////////////////////////////////////////////
    builder
      .addCase(RecommendationScientificBodyButtons.pending, (state, action) => {
        state.loadingRecommendationScientificBodyButtons = true;
        state.RecommendationScientificBodyButtons = action.payload;
        state.RecommendationScientificBodyButtons = null;
      })
      .addCase(
        RecommendationScientificBodyButtons.fulfilled,
        (state, action) => {
          state.loadingRecommendationScientificBodyButtons = false;
          state.RecommendationScientificBodyButtons = action.payload;
        }
      )
      .addCase(
        RecommendationScientificBodyButtons.rejected,
        (state, action) => {
          state.loadingRecommendationScientificBodyButtons = false;
          state.errorRecommendationScientificBodyButtons = action.payload;
        }
      );
      //////////////////////////////////////////////////////////////
    builder
      .addCase(
        GetAllSubTaskForScientificBodyAssigningBysubtask.pending,
        (state, action) => {
          state.loadingGetAllSubTaskForScientific = true;
          state.GetAllSubTaskForScientific = action.payload;
          state.GetAllSubTaskForScientific = null;
        }
      )
      .addCase(
        GetAllSubTaskForScientificBodyAssigningBysubtask.fulfilled,
        (state, action) => {
          state.loadingGetAllSubTaskForScientific = false;
          state.GetAllSubTaskForScientific = action.payload;
        }
      )
      .addCase(
        GetAllSubTaskForScientificBodyAssigningBysubtask.rejected,
        (state, action) => {
          state.loadingGetAllSubTaskForScientific = false;
          state.errorGetAllSubTaskForScientific = action.payload;
        }
      );
  },
});


export default ScientificCommittee.reducer;
